<template>
  <div class="component-content sub-content">
    <div class="list-title">
      <label class="label-name">当前仓库：</label>
      <el-select size="small" class="organization-select" v-model="houseId" placeholder="请选择仓库">
        <el-option v-for="item in houseList" :key="item.id" :label="item.name" :value="item.id">
        </el-option>
      </el-select>
      <label style="margin-left:10px;" class="label-name">搜索：</label>
      <el-input style="display:inline-block;width:350px;" v-model="filterKey" size="small"
        placeholder="你可以搜索材料出库管理员/出库单号/工程客户名"></el-input>
    </div>

    <el-table :data="paginationData" border style="width: 100%" v-loading="loading">

      <el-table-column prop="number" label="出库单号" width="100px" align="center">
      </el-table-column>
      <!-- <el-table-column label="出库单材料">
        <template slot-scope="scope">
          <span v-html="getOutMaterials(scope.row)"></span>
        </template>
      </el-table-column> -->
      <el-table-column prop="projectName" label="工程">
        <!-- <template slot-scope="scope">
          <user-info :userData='scope.row.projectName'></user-info>
        </template> -->
      </el-table-column>
      <el-table-column prop="customer" label="客户">
        <!-- <template slot-scope="scope">
          <user-info :userData='scope.row.user'></user-info>
        </template> -->
      </el-table-column>
      <el-table-column label="出库管理员" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.creator'></user-info>
        </template>
      </el-table-column>
      <el-table-column prop="time" label="出库时间" width="140px">
      </el-table-column>
      <el-table-column label="操作" width="60">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="ShowMaterialUseOutDetail(scope.row)" type="primary">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <material-use-out-detail v-on:hideDetail="hideDetail()" :detailStatus="detailStatus"
      :materialOutData="materialOutData">
    </material-use-out-detail>

  </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import UserInfo from "@/components/UserInfo";
import MaterialUseOutDetail from "@/page/storage/components/materialUseOutDetail";
export default {
  components: {
    UserInfo,
    MaterialUseOutDetail,
  },
  computed: {
    ...mapState({
      organization: (state) => state.main.organization,
      userData: (state) => state.main.userData,
      managerStorage: (state) => state.storage.managerStorage,
    }),
  },
  data() {
    return {
      supplierList: "",
      // 出库单明细详情
      detailStatus: false,
      materialOutData: "",

      houseId: "",
      depId: "",
      houseList: "",

      organizationListData: [],
      noSelectOrganization: true,
      // 列表
      loading: true,
      pageSize: 20,
      currentPage: 1,
      listData: [],
      filterData: [],
      paginationData: [],
      filterKey: "",
    };
  },
  created() {
    if (this.$route.params.houseId) {
      this.houseId = this.$route.params.houseId / 1;
    }
    this.depId = this.userData.secDepIds.split(",")[0] / 1;
    // 获取仓库列表
    this.getHouseList();

    // 获取供应商列表
    ajax.get(
      "/supplier/list",
      {
        type: 1,
      },
      (res) => {
        // this.loading = false
        this.supplierList = res.vo.array;
      }
    );
  },
  mounted() {
    this.organizationListData = this.organization[0].childDepts;
    this.depId = this.userData.secDepIds.split(",")[0] / 1;

    if (this.userData.secDepIds.split(",")[0] == "7") {
      this.noSelectOrganization = false;
    }
  },
  methods: {
    // 组装出库单材料
    getOutMaterials(row) {
      let _m = [];
      for (var i = 0; i < row.materials.length; i++) {
        let _item = row.materials[i];
        _m.push(_item.name + "（" + _item.amount + _item.unitName + "）");
      }
      return _m.join(",");
    },
    // 隐藏详情
    hideDetail() {
      this.detailStatus = false;
    },
    // 显示出库单详情
    ShowMaterialUseOutDetail(row) {
      this.materialOutData = row;
      this.detailStatus = true;
    },
    // 获取仓库列表
    getHouseList() {
      // 只能看到拥有权限的仓库
      this.houseList = this.managerStorage;

      if (!this.houseId && this.houseList.length > 0) {
        this.houseId = this.houseList[0].id;
      }

      this.getLists();
    },
    // 当前页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPaginationData();
    },
    // 搜索筛选新闻数据
    getFilterData() {
      // console.log(this.filterKey)
      if (this.filterKey) {
        // 筛选出所有符合的数据
        this.filterData = [];
        for (let i = 0; i < this.listData.length; i++) {
          let _item = this.listData[i];
          let _filterKeyLower = this.filterKey.toLowerCase();

          if (
            _item.creator.name.toLowerCase().indexOf(_filterKeyLower) != -1 ||
            (_item.projectName &&
              _item.projectName.toLowerCase().indexOf(_filterKeyLower) != -1) ||
            (_item.customer &&
              _item.customer.toLowerCase().indexOf(_filterKeyLower) != -1) ||
            (_item.number &&
              _item.number.toLowerCase().indexOf(_filterKeyLower) != -1)
          ) {
            this.filterData.push(_item);
          }
        }
      } else {
        this.filterData = this.listData;
      }
      this.currentPage = 1;
      this.getPaginationData();
    },
    // 分页筛选数据
    getPaginationData() {
      if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
        this.currentPage = Math.ceil(this.filterData.length / this.pageSize);
      }
      if (this.currentPage == 0) {
        this.currentPage = 1;
      }
      // 分页筛选
      this.paginationData = this.filterData.slice(
        this.pageSize * (this.currentPage - 1),
        this.pageSize * this.currentPage
      );
    },
    // 获取列表
    getLists() {
      if (!this.houseId) {
        return;
      }
      this.loading = true;

      ajax.get(
        "/storage/material/out/list",
        {
          houseId: this.houseId,
        },
        (res) => {
          this.loading = false;
          this.filterData = this.listData = res.vo.array;
          this.getFilterData();
        }
      );
    },
  },
  watch: {
    houseId() {
      this.getLists();
    },
    filterKey() {
      this.getFilterData();
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/page/storage/materialUseOutList.vue